import { render, staticRenderFns } from "./HomeworkInformation.vue?vue&type=template&id=d70cb99e&scoped=true&lang=pug&"
import script from "./HomeworkInformation.vue?vue&type=script&lang=ts&"
export * from "./HomeworkInformation.vue?vue&type=script&lang=ts&"
import style0 from "./HomeworkInformation.vue?vue&type=style&index=0&id=d70cb99e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70cb99e",
  null
  
)

export default component.exports